import * as Yup from 'yup';

// ----------------------------------------------------------------------

export const TrinksFormSchema = Yup.object().shape({
  integrationId: Yup.string().required('Preenchimento Obrigatório'),
  apiKey: Yup.string().required('Preenchimento Obrigatório'),
  activated: Yup.boolean().required(),
});

export type TTrinksConfigFormSchema = Yup.InferType<typeof TrinksFormSchema>;

export const trinksConfigFormSchemaDefaultValues: TTrinksConfigFormSchema = {
  integrationId: '',
  apiKey: '',
  activated: true,
};
